<script setup>
// Projects — the TENANT-ADMIN per-project membership page, in the consumer shell.
//
// A workspace admin manages projects and who's on each. Every tenant has a root
// "Default" project (auto-provisioned by saas-core); departments (e.g. Nursing,
// Cardiology) are added alongside it. Backed by saas-core's
// /api/tenant/teams/projects* surface (createTeamRoutes, tenant-admin gated).
//
// AdminProjects is self-contained (inline add/role/remove), so this wrapper just
// supplies the heading. Same placement pattern as TeamPage.vue.
import AdminProjects from "@digitalstreams/saas-core/vue/admin/AdminProjects.vue";
</script>

<template>
  <div class="container-fluid p-0">
    <h1 class="h3 mb-1">Projects</h1>
    <p class="text-muted mb-3">
      Manage projects and their members. The <strong>Default</strong> project covers
      your whole workspace; add more for departments or teams that need their own people.
    </p>

    <AdminProjects />
  </div>
</template>
